/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BusinessCategoryLv2,
    BusinessCategoryLv2FromJSON,
    BusinessCategoryLv2FromJSONTyped,
    BusinessCategoryLv2ToJSON,
} from './BusinessCategoryLv2';

/**
 * 
 * @export
 * @interface BusinessCategoryV2
 */
export interface BusinessCategoryV2 {
    /**
     * メインビジネスカテゴリID
     * @type {string}
     * @memberof BusinessCategoryV2
     */
    busiCateId: string;
    /**
     * メインビジネスカテゴリ名
     * @type {string}
     * @memberof BusinessCategoryV2
     */
    busiCateName: string;
    /**
     * ビジネスカテゴリに属するサブビジネスカテゴリ一覧
     * @type {Array<BusinessCategoryLv2>}
     * @memberof BusinessCategoryV2
     */
    busiCateLv2: Array<BusinessCategoryLv2>;
}

export function BusinessCategoryV2FromJSON(json: any): BusinessCategoryV2 {
    return BusinessCategoryV2FromJSONTyped(json, false);
}

export function BusinessCategoryV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessCategoryV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'busiCateId': json['busi_cate_id'],
        'busiCateName': json['busi_cate_name'],
        'busiCateLv2': ((json['busi_cate_lv2'] as Array<any>).map(BusinessCategoryLv2FromJSON)),
    };
}

export function BusinessCategoryV2ToJSON(value?: BusinessCategoryV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'busi_cate_id': value.busiCateId,
        'busi_cate_name': value.busiCateName,
        'busi_cate_lv2': ((value.busiCateLv2 as Array<any>).map(BusinessCategoryLv2ToJSON)),
    };
}

